import { sha256 } from "js-sha256";

export const redirectToScanApp = (phone: string) => {
  const hostName = "https://receipt-adg.jetcrm.ru/";
  const currentPage = window.location.href;
  const salt = "aVMzrolj5wfyjtpHYV5w";

  window.location.href = `${hostName}?msisdn=${phone}&mall_id=${localStorage.getItem(
    "mall_id"
  )}&signature=${sha256(phone + salt)}&redirect=${encodeURIComponent(
    currentPage
  )}`;
};
